export default function monitorLog(log, logType, addColor = false) {
  let _log = [...log];

  if (logType === "string") {
    _log.forEach(item => {
      item = filterLogItem(item);
    });
    return _log.filter(item => item !== '');

  } else {
    let newLog = []
    _log.forEach(item => {
      if (typeof item === "string") {
        const logItem = filterLogItem(item);
        newLog.push({
          log: logItem,
          colorClassName: addColorClassName(logItem)
        })
      } else {
        item.log = filterLogItem(item.log);
        //add color className
        if (addColor && item.log) {
          item.colorClassName = addColorClassName(item.log);
        }
        newLog.push(item);
      }

    });
    return newLog.filter(item => item.log !== '');
  }
}

function filterLogItem(log) {
  // Remove blank log
  log = log.replace(/(^\s*)|(\s*$)/g, "");
  /* let regC = /[\u4e00-\u9fa5]+/g;
  if (regC.test(log)) {
    log = '';
  } */
  if (log.search(/\[Progress\]/g) > -1) {
    log = '';
  }
  return log;
}

const FILTER_ERROR_REG = /(check errors)|(file failed)|(\[Warning\])|(error.*fitting|fitting.*error)|(RMS Error)|(bit error rate)|(Errors: 0)|(Errors:0)/i;
const FILTER_WARNING_REG = /(not found connectable PCB)|(Not found extraction result)|(Model dost not exist,)/i;

function addColorClassName(log) {
  const filter = log.match(FILTER_ERROR_REG);

  if (!filter && log.match(/\b(?:errors?|fail(?:ed|ure)?)\b|(Invalid)/i)) {
    return "aurora-msg-error";
  }
  const filterWarn = log.match(FILTER_WARNING_REG);
  if (!filterWarn && log.match(/\b(?:warnings?|warn)\b|\b(?:not (?:exist|found|find))\b/i)) {
    return "aurora-msg-warning";
  }

  if (log.match("Extract the models of the PCBs")) {
    return "aurora-msg-bold";
  }
  return null;
}

function updateLogFormat(log) {
  let logs = [];
  if (typeof log !== "string") {
    return [log]
  }
  const lines = log.match(/[^\r\n]+/g);
  if (!lines || !lines.length) {
    return [log]
  }
  for (let mesItem of lines) {
    logs.push({
      log: mesItem,
      colorClassName: mesItem ? addColorClassName(mesItem) : null
    })
  }
  return logs;
}

function updateSimulationLogFormat(log) {
  let logs = [];
  if (typeof log === "string") {
    return updateLogFormat(log);
  }

  for (let mesItem of log) {
    logs.push({
      log: mesItem,
      colorClassName: mesItem ? addColorClassName(mesItem) : null
    })
  }
  return logs;
}

function getColorClassNameByPrefix(log) {

  if ((log || "").match(/\[Error\]/i)) {
    return "aurora-msg-error";
  }
  if ((log || "").match(/\[Warning\]/i)) {
    return "aurora-msg-warning";
  }

  return null;
}

export {
  updateLogFormat,
  getColorClassNameByPrefix,
  updateSimulationLogFormat
}